import { MAX_AGE } from "../../constants";

export const isEmailValid = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const isNameValid = (name: string): boolean => {
	const nameParts = name.split(" ");
	return nameParts.length >= 2 && nameParts[0].length > 0 && /[a-zA-Z]/.test(nameParts[1]);
};

export const isPhoneNumberValid = (phone: string): boolean => /^\(\d{2}\) \d{5} \d{4}$/.test(phone);

export const validMinAge = (data: string, ageMin: number): boolean => {
	const dataParts = data.split("/");
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();
	const currentMonth = currentDate.getUTCMonth() + 1;
	const currentDay = currentDate.getUTCDate();

	let age = currentYear - Number(dataParts[2]);

	if (currentMonth > Number(dataParts[1])) {
		return age >= ageMin;
	}

	if (currentDay >= Number(dataParts[0])) {
		return age >= ageMin;
	}

	age -= 1;

	return age >= ageMin;
};

// Verifica se idade é menor que a idade máxima permitida
export const validMaxAge = (date: string, ageMax?: number): boolean => {
	const maxAgeDefault = ageMax || MAX_AGE;
	const dataParts = date.split("/");
	const today = new Date();
	const birth = new Date(Number(dataParts[2]), Number(dataParts[1]) - 1, Number(dataParts[0]));

	let age = today.getFullYear() - birth.getFullYear();
	const month = today.getMonth() - birth.getMonth();

	// Ajusta a idade se ainda não fez aniversário este ano
	if (month < 0 || (month === 0 && today.getDate() < birth.getDate())) {
		age--;
	}

	return age <= maxAgeDefault;
};
